import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group bg-bg-items-white relative z-0 flex cursor-pointer gap-4 px-4 pt-5 pb-4 transition-colors hover:bg-[#F9FBFB] lg:gap-5',
    link: 'absolute inset-0 z-10 cursor-pointer',
    image: 'block size-[110px]',
    contentWrapper: 'flex w-full flex-col gap-2',
    labelContainer: 'z-20 flex gap-1 max-md:flex-wrap',
    title: 'heading-xs-bold lg:heading-text-s-bold lg:w-5/6',
    subtitle: 'heading-xs',

    priceContainer: 'flex items-center justify-between',
    price: 'heading-s-bold md:heading-m-bold',
    oldPrice: 'heading-s md:heading-s',

    buyButton: 'z-20 size-10 p-0 outline-none',

    chevron:
      'absolute top-16 right-6 opacity-0 transition-opacity lg:group-hover:opacity-100',
    arrow: 'lg:hidden'
  }
});
